import { PassengerFiltersData } from './types';

export const EMPTY_PASSENGER_FILTERS_DATA: PassengerFiltersData = {
	allowedFilters: [],
	availableSeats: []
};
